class EcomComparisonSlider {
  constructor(element) {
    this.container = element;
    this.handle = element.querySelector('[data-slider-handle]');
    this.beforeImage = element.querySelector('.ecom-comparison-slider__image-container--before');
    
    if (!this.handle || !this.beforeImage) return;
    
    this.isDragging = false;
    this.containerRect = null;
    
    this.init();
  }
  
  init() {
    // Mouse events
    this.handle.addEventListener('mousedown', this.startDrag.bind(this));
    document.addEventListener('mousemove', this.drag.bind(this));
    document.addEventListener('mouseup', this.stopDrag.bind(this));
    
    // Touch events for mobile
    this.handle.addEventListener('touchstart', this.startDrag.bind(this), { passive: false });
    document.addEventListener('touchmove', this.drag.bind(this), { passive: false });
    document.addEventListener('touchend', this.stopDrag.bind(this));
    
    // Click on container to move slider
    this.container.addEventListener('click', this.handleContainerClick.bind(this));
    
    // Prevent default drag behavior on images
    this.container.addEventListener('dragstart', (e) => e.preventDefault());
    
    // Update container rect on resize
    window.addEventListener('resize', this.updateContainerRect.bind(this));
    this.updateContainerRect();
  }
  
  updateContainerRect() {
    this.containerRect = this.container.getBoundingClientRect();
  }
  
  startDrag(e) {
    this.isDragging = true;
    this.updateContainerRect();
    
    // Prevent default to avoid text selection and image dragging
    e.preventDefault();
    
    // Add dragging class for visual feedback
    this.container.classList.add('ecom-comparison-slider--dragging');
    
    // Disable transitions during drag
    this.beforeImage.style.transition = 'none';
  }
  
  drag(e) {
    if (!this.isDragging) return;
    
    e.preventDefault();
    
    // Get the x position from mouse or touch event
    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    
    // Calculate percentage based on container position
    const x = clientX - this.containerRect.left;
    const percentage = Math.max(0, Math.min(100, (x / this.containerRect.width) * 100));
    
    this.updateSlider(percentage);
  }
  
  stopDrag() {
    if (!this.isDragging) return;
    
    this.isDragging = false;
    this.container.classList.remove('ecom-comparison-slider--dragging');
    
    // Re-enable transitions
    this.beforeImage.style.transition = 'clip-path 0.1s ease-out';
  }
  
  handleContainerClick(e) {
    // Don't handle clicks on the handle itself
    if (e.target.closest('[data-slider-handle]')) return;
    
    this.updateContainerRect();
    
    const x = e.clientX - this.containerRect.left;
    const percentage = Math.max(0, Math.min(100, (x / this.containerRect.width) * 100));
    
    this.updateSlider(percentage);
  }
  
  updateSlider(percentage) {
    // Update the clip-path of the before image
    this.beforeImage.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
    
    // Update handle position
    this.handle.style.left = `${percentage}%`;
  }
}

// Initialize all comparison sliders when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[data-comparison-slider]');
  sliders.forEach(slider => new EcomComparisonSlider(slider));
});

// Re-initialize on Shopify section loads (for theme editor)
document.addEventListener('shopify:section:load', (e) => {
  const sliders = e.target.querySelectorAll('[data-comparison-slider]');
  sliders.forEach(slider => new EcomComparisonSlider(slider));
}); 